import React, { useState, useEffect } from 'react';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import NewReportForm from '../components/dashboard/NewReportForm';
import SuccessMessage from '../components/dashboard/SuccessMessage';
import CreditsIndicator from '../components/dashboard/CreditsIndicator';
import { useReports } from '../hooks/useReports';

export default function Dashboard() {
  const location = useLocation();
  const message = location.state?.message;
  const { reports, loading, error, refreshReports } = useReports();
  const [localReports, setLocalReports] = useState(reports);
  const navigate = useNavigate();

  useEffect(() => {
    setLocalReports(reports);
  }, [reports]);

  const handleNewReport = (newReport) => {
    setLocalReports((prevReports) => [...prevReports, newReport]);
    navigate('/reports');
  };

  return (
    <DashboardLayout>
      <div className="p-6">
        {message && <SuccessMessage message={message} />}
        
        <div className="mb-8">
          <CreditsIndicator />
        </div>

        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">New Report</h1>

          <div className="max-w-2xl bg-white rounded-lg shadow p-6">
            <NewReportForm onNewReport={handleNewReport} />
          </div>
        </div>
        <Outlet />
      </div>
    </DashboardLayout>
  );
}